import { h, render } from 'preact'
import { isEmptyArray, isObject, hasOwnDeepProperty, comparePriority } from '../modules/utilities.js'
import { setAllToMaxHeight } from '../modules/setAllToMaxHeight.js'
import { SG1Logs } from '../modules/logs.js'

/**
 * --------------------------------------------------------------------------
 * renderAdvise ()
 * Pour chaque [data-advcontent]
 * Si advise :
 * - Récuperation des noeuds adv voulu
 * - Récuperation des datas associées à ces noeuds
 * - Templating de ces data en HTML
 * - Injection de l'HTML dans le DOM
 * Si fallback magic :
 * - Récuperation des datas dans .fallback-magic
 * - Templating de ces data en HTML
 * - Injection de l'HTML dans le DOM
 *
 * @param {function} adviseTemplates jsx template
 * @param {object} adviseData json from Advise webservice cleaned up
 * --------------------------------------------------------------------------
 */
export function renderAdvise(adviseTemplates, adviseData) {
   let logState = '0'
   let fallbackDatas

   document.querySelectorAll('[data-advcontent]').forEach(($elmt) => {
      let rendered
      let adviseNode
      fallbackDatas = ''

      try {
         let slider = []

         // - - -   S A N I T I Z E   - - -
         if (isObject(adviseData)) {
            // If advise responds, get advise data
            // En mode TopScore, on récupère le refzone

            adviseNode = $elmt.dataset.refzone.split(',')

            const datas = mapToData(adviseNode, adviseData)

            // Extract rules (properties to check) from the DOM (like: data-advtest="url, mobule.submodule.property, other-property")
            const advTest = $elmt.dataset.advtest
            const rules = typeof advTest === 'string' ? advTest.trim().split(',') : []

            // Si on a pas tous les champs attendus, on retourne un tableau vide sinon on retourne toutes les données advise de la zone
            slider = datas.filter((slide) => isObject(slide) && rules.every((rule) => hasOwnDeepProperty(slide, rule)))
         }

         // - - -   F A L L B A C K   - - -
         // Si "needFallback === true" on déclenche l'affichage fallback
         const needFallback = isEmptyArray(slider) && 'advNoFallback' in $elmt.dataset === false

         // Récupération des données de fallback
         if (needFallback) {
            const $fallbackElmt = $elmt.querySelector('.fallback-magic')
            const rawDatas = $fallbackElmt.innerText
            try {
               fallbackDatas = JSON.parse(rawDatas)
            } catch (error) {
               console.error('Catch error: fallbackDatas', error)
               SG1Logs.incLog('Err_CORCH')
               SG1Logs.sentryEvent({ error: error, data: rawDatas, name: 'RenderAdvise FallbackDatas Orchestrator' })
            }
         }

         // - - -   R E F   Z O N E   - - -
         slider.forEach((slide) => {
            // Add refZone
            slide.refZone = $elmt.dataset.refzone
            slide.indexParent = $elmt.dataset.index
         })

         // - - -   R E N D E R   - - -
         let template
         let advtpl = $elmt.dataset.advtpl //nom du template

         if (adviseTemplates && typeof adviseTemplates === 'object' && adviseTemplates.hasOwnProperty(advtpl)) {
            template = adviseTemplates[advtpl]
         } else {
            throw new Error('The advise template was not found')
         }

         let ComponentName = template
         if (typeof ComponentName === 'function') {
            let props = isEmptyArray(slider) ? fallbackDatas : slider
            if (props.length > 0) {
               render(<ComponentName {...props} />, $elmt)
               let scriptFallback = $elmt.querySelector('.fallback-magic')
               if (scriptFallback !== null) scriptFallback.remove()
            }
         }
      } catch (error) {
         console.error('Catch error: renderAdvise()', error)
         SG1Logs.incLog('Err_CORCH')
         SG1Logs.sentryEvent({ error: error, name: 'Render Advise Orchestrator' })
      }
   })

   setAllToMaxHeight('.btn-custom-height') // resize pour les boutons dans parcours marchand
}

/**
 * --------------------------------------------------------------------------
 * mapToData ()
 * Récuperation des noeuds advice demandés par l'item
 * Concatenation des noeuds
 * Classement des noeuds par priorité
 * --------------------------------------------------------------------------
 */
function mapToData(adviseNode, adviseData) {
   let d = []
   for (let i = 0, l = adviseNode.length; i < l; i++) {
      d = d.concat(adviseData[adviseNode[i]])
   }
   d.sort(comparePriority)
   return d
}
